import React, { Component } from "react"
import moment from "moment"
import { withTranslation } from "react-i18next"
import { isUsaa } from "../helpers/affiliationHelpers"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { withRouter } from "react-router-dom"
import { routerPaths } from "../constants/paths"

class RegFooter extends Component {
  state = {
    isTopTireRoute: false
  }

  componentDidMount() {
    this.checkTopTireRoute()
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the URL has changed and re-compute the route check
    const { history } = this.props
    if (history.location.pathname !== prevState.currentUrl) {
      this.checkTopTireRoute()
    }
  }

  checkTopTireRoute() {
    const { history } = this.props

    const isTopTireRoute = history.location.pathname.includes(routerPaths.topTires)
    this.setState({
      isTopTireRoute,
      currentUrl: history.location.pathname
    })
  }

  render() {
    const { t, savedTires, history } = this.props

    const { isTopTireRoute } = this.state
    const isServiceRequest = history.location.pathname.includes("/service-request")

    return (
      <div
        className={`footer ${
          isTopTireRoute && !isEmpty(savedTires) ? "top-tire-margin-bottom" : ""
        } ${isUsaa() && !isServiceRequest ? "show-footer" : ""}`}
      >
        <p>
          {t("termsAndConditions1")}
          <span className="underline">
            <strong>
              <a href="https://caradvise.com/privacy" target="_blank" className="disclaimer">
                {t("termsAndConditions2")}
              </a>
            </strong>
          </span>
          {t("termsAndConditions3")}
          <span className="underline">
            <strong>
              <a href="https://caradvise.com/terms" target="_blank" className="disclaimer">
                {t("termsAndConditions4")}
              </a>
            </strong>
          </span>
        </p>
        &copy; {`${moment().year()} ${t("footerText")}`}
        <span> {process.env.REACT_APP_COMMIT_SHA}</span>
        {isUsaa() && (
          <React.Fragment>
            <p className="underline">
              <strong>
                <a href="https://www.usaaperks.com" target="_blank" className="disclaimer">
                  {t("returnToUsaa")}
                </a>
              </strong>
            </p>
            <p className="disclaimer" style={{ padding: "15px", textAlign: "left" }}>
              <strong>{t("caradviseDisclosuresText")}</strong>
              <br />
              <br />
              {t("allServicesBookedDesc")}{" "}
              <a href="https://caradvise.com/terms/" target="_blank" className="disclaimer">
                {t("termsOfUseText")}
              </a>
              {t("anyInfoYouProvideDesc")}
              <a href="https://caradvise.com/privacy/" target="_blank" className="disclaimer">
                {t("privacyPolicyText")}
              </a>
              .
              <br />
              <br />
              {t("savingsVaryDesc")}
              <br />
              <br />
              {t("finalPricesForServicesDesc")}
              <br />
              <br />
              {t("priceGuaranteeText")}
              <br />
              {t("guaranteedPriceDesc")}
              <br />
              <br />
              {t("happinessGuaranteedText")}
              <br />
              {t("notSatisfiedWithServiceDesc")}
              <br />
              <br />
              <strong>{t("usaaDisclosuresText")}</strong>
              <br />
              <br />
              {t("usaaMeanDesc")}
              <br />
              <br />
              {t("useOfTermsDesc")}
              <br />
              <br />
              {t("allianceServicesDesc")}
              <br />
              <br />
              {t("propertyOfOwnerDesc")}
              <br />
              <br />
              {t("usaaDidNumber")}
              <br />
              <br />
            </p>
          </React.Fragment>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  let savedTires = state.saveBuyTireDetails.tireArray
  return {
    savedTires: savedTires
  }
}

export default withRouter(connect(mapStateToProps, null)(withTranslation("regFooter")(RegFooter)))
